import get from "lodash/get"
import isEmpty from "lodash/isEmpty"
import filter from "lodash/filter"
import isString from "lodash/isString"
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager"

export const InteractiveMapMappedPath = `wm/components/content/interactiveMap`
export const InteractiveMapEditConfig = {
  emptyLabel: `Please Configure Interactive Map`,
  isEmpty(props) {
    return !props || !props.title
  },
}

export const CrossPollinationMappedPath = `wm/components/content/cross-pollination`
export const CrossPollinationEditConfig = {
  emptyLabel: `Please configure Cross Pollination`,
  isEmpty(props) {
    return !props || !get(props, `gridInfo`, []).length
  },
}

export const FloatingADSRegistrationCardMappedPath = `wm/components/content/floatingadsregistrationcard`
export const FloatingADSRegistrationCardEditConfig = {
  emptyLabel: `Please Configure Floating ADS Registration Card`,
  isEmpty(props) {
    return !props || !props.cards || props.cards.length < 1
  },
}

export const CommercialServiceMappedPath = `wm/components/content/ecom/commercialService`
export const CommercialServiceEditConfig = {
  emptyLabel: `Please Configure Commercial Service Component`,
  isEmpty(props) {
    return !props
  },
}

export const DiagramAnnotationMappedPath = `wm/components/content/diagramAnnotation`
export const DiagramAnnotationEditConfig = {
  emptyLabel: `Please Configure Diagram and Annotation`,
  isEmpty(props) {
    const annotationData = get(props, `diagramAnnotationList`, [])
    return !props || !get(props, `headline`, ``) || !annotationData.length
  },
}

export const BreadcrumbBannerMappedPath = `wm/components/content/preferencesearch/breadcrumbbanner`
export const BreadcrumbBannerEditConfig = {
  emptyLabel: `Please Configure Breadcrumb Banner`,
  isEmpty(props) {
    return !props
  },
}

export const WidgetModalMappedPath = `wm/components/content/widgetmodal`
export const WidgetModalEditConfig = {
  emptyLabel: `Please Configure Widget Modal`,
  isEmpty() {
    return true
  },
}

export const BreadcrumbStandaloneMappedPath = `wm/components/content/breadcrumb`
export const BreadcrumbStandaloneEditConfig = {
  emptyLabel: `Please Configure Story Mosaic`,
  isEmpty(props) {
    return !props || !props.mosaicDetails || props.mosaicDetails.length < 1
  },
}

export const StoryMosaicMappedPath = `wm/components/content/storymosaic`
export const StoryMosaicEditConfig = {
  emptyLabel: `Please Configure Story Mosaic`,
  isEmpty(props) {
    return !props || !props.mosaicDetails || props.mosaicDetails.length < 1
  },
}

export const GuidedFlowMappedPath = `wm/components/content/guidedflow`
export const GuidedFlowEditConfig = {
  emptyLabel: `Please Configure Guided Flow Component`,

  isEmpty(props) {
    return !props || !props.text || props.text.trim().length < 1
  },
}

export const VideoPlayListMappedPath = `wm/components/content/videoPlaylist`
export const VideoPlayListEditConfig = {
  emptyLabel: `Please Configure Video PlayList`,
  isEmpty(props) {
    return !props || !get(props, `videoData`, []).length
  },
}

export const FullWidthAutoPlayVideoMappedPath = `wm/components/content/fullWidthAutoplay`
export const FullWidthAutoPlayVideoEditConfig = {
  emptyLabel: `Please Configure Full Width Autoplay Video Component`,
  isEmpty(props) {
    return !props
  },
}

export const ProductComparisonTableMappedPath = `wm/components/content/basicTable`
export const ProductComparisonTableEditConfig = {
  emptyLabel: `Please Configure Basic Product Comparison Table`,
  isEmpty(props) {
    return !props || !props.columnTitle.length > 0
  },
}

export const ADSRegistrationConfirmationMappedPath = `wm/components/content/adsregistrationconfirmation`
export const ADSRegistrationConfirmationEditConfig = {
  emptyLabel: `Please Configure ADS Registration Confirmation Component`,
  isEmpty(props) {
    return !props
  },
}

export const SimplifiedNavigationMappedPath = `wm/components/content/simplifiednavigation`
export const SimplifiedNavigationEditConfig = {
  emptyLabel: `Please Configure Simplified Navigation`,
  isEmpty(props) {
    return !props
  },
}

export const RequestSupportMappedPath = `wm/components/content/requestsupport`
export const RequestSupportEditConfig = {
  emptyLabel: `Please Configure RequestSupport`,
  isEmpty(props) {
    return !props
  },
}

export const MDSGraphicMappedPath = `wm/components/content/mdsgraphic`
export const MDSGraphicEditConfig = {
  emptyLabel: `Please Configure MDSGraphic`,
  isEmpty(props) {
    return !props
  },
}

export const MobileCallToOrderMappedPath = `wm/components/content/mobilecalltoorder`
export const MobileCallToOrderEditConfig = {
  emptyLabel: `Please configure Call To Order`,
  isEmpty(props) {
    return !props
  },
}

export const SimplifiedFooterMappedPath = `wm/components/content/simplifiedfooter`
export const SimplifiedFooterEditConfig = {
  emptyLabel: `Please configure simplified footer`,
  isEmpty(props) {
    return !props || !props.logoCTALink
  },
}

export const FooterBasicMappedPath = `wm/components/content/technology/footerbasic`
export const FooterBasicEditConfig = {
  emptyLabel: `Please Configure Basic Footer Component`,
  isEmpty(props) {
    return isEmpty(props)
  },
}

export const HeaderBasicMappedPath = `wm/components/content/technology/headerbasic`
export const HeaderBasicEditConfig = {
  emptyLabel: `Please Configure Basic Header Component`,
  isEmpty(props) {
    return isEmpty(props)
  },
}

export const SideNavMappedPath = `wm/components/content/textblockwithsidenav`
export const SideNavEditConfig = {
  emptyLabel: `Please Configure Text Blocks with Optional Side Nav`,
  isEmpty(props) {
    return !props.displayPattern
  },
}

export const StoryCarouselMappedPath = `wm/components/content/storyCarousel`
export const StoryCarouselEditConfig = {
  emptyLabel: `Please Configure Story Carousel`,
  isEmpty(props) {
    return (
      !props ||
      typeof props.storyCarouselList !== `object` ||
      props.storyCarouselList.length === 0
    )
  },
}

export const LicensingAgreementModalMappedPath = `wm/components/content/licensingagreementmodal`
export const LicensingAgreementModalEditConfig = {
  emptyLabel: `Please Configure Licensing Agreement Modal`,
  isEmpty(props) {
    return !props
  },
}

export const TopSupportTopicsMappedPath = `wm/components/content/topsupporttopics`
export const TopSupportTopicsEditConfig = {
  emptyLabel: `Please Configure TopSupportTopics`,
  isEmpty(props) {
    return !props
  },
}

export const ReviewCarouselMappedPath = `wm/components/content/reviewcarousel`
export const ReviewCarouselEditConfig = {
  emptyLabel: `Please Configure Review Carousel`,
  isEmpty(props) {
    return (
      !props || !props.reviewCarouselList || props.reviewCarouselList.length < 1
    )
  },
}

export const ResidentialServiceMappedPath = `wm/components/content/ecom/residentialService`
export const ResidentialServiceEditConfig = {
  emptyLabel: `Please Configure Commercial Service Component`,
  isEmpty(props) {
    return !props
  },
}

export const QuizGameMappedPath = `wm/components/content/multiplechoicecards`
export const QuizGameEditConfig = {
  emptyLabel: `Please Configure Multiple Choice Cards Component`,
  isEmpty(props) {
    return !props || isEmpty(props.cardDetails)
  },
}

export const LinkGridTileMappedPath = `wm/components/content/linkgridtile`
export const LinkGridTileEditConfig = {
  emptyLabel: `Please Configure Link Tile Grid`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const SupportSearchMappedPath = `wm/components/content/supportsearch`
export const SupportSearchEditConfig = {
  emptyLabel: `Please Configure Site Search`,
  isEmpty(props) {
    return !props
  },
}

export const TabbedAddressSearchMappedPath = `wm/components/content/tabbedaddresssearchcontent`
export const TabbedAddressSearchEditConfig = {
  emptyLabel: `Please Configure Tabbed Address Search Content Component`,
  isEmpty(props) {
    return !props.tabProperties.length > 0
  },
}

export const FeaturedContentCardsMappedPath = `wm/components/content/featuredcontentcards`
export const FeaturedContentCardsEditConfig = {
  emptyLabel: `Please Configure Featured Content Card`,
  isEmpty(props) {
    return (
      !props ||
      !props.featuredContentCards ||
      props.featuredContentCards.length < 1
    )
  },
}

export const HorizontalListMappedPath = `wm/components/content/horizontallist`
export const HorizontalListEditConfig = {
  emptyLabel: `Please Configure Horizontal List`,
  isEmpty(props) {
    return !props.heading
  },
}

export const TabbedContentMappedPath = `wm/components/content/tabbedcontent`
export const TabbedContentEditConfig = {
  emptyLabel: `Please Configure Tabbed Content`,
  isEmpty(props) {
    return !props || props.contentTabs.length === 0
  },
}

export const HomepageAddressInputMappedPath = `wm/components/content/homepageaddressinput`
export const HomepageAddressInputEditConfig = {
  emptyLabel: `Please Configure Homepage Address Input & Self Serve`,
  isEmpty(props) {
    return (
      !props ||
      isEmpty(props.userStatesAndLobs) ||
      (!isString(get(props, `quickServe.quickLinksEyebrowText`, ``)) &&
        !isString(get(props, `addressSearch.h1EyebrowText`, ``))) ||
      isEmpty(
        get(props, `quickServe.serviceLinks`, []) &&
          isEmpty(get(props, `addressSearch.lobTabDetails`, [])),
      )
    )
  },
}

export const RelatedArticlesMappedPath = `wm/components/content/relatedArticles`
export const RelatedArticlesEditConfig = {
  emptyLabel: `Please Configure Related Article`,
  isEmpty(props) {
    return !props.heading
  },
}

export const TopTopicsMappedPath = `wm/components/content/toptopics`
export const TopTopicsEditConfig = {
  emptyLabel: `Please Configure Top Topics`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const TopicsPageMappedPath = `wm/components/content/topicspage`
export const TopicsPageEditConfig = {
  emptyLabel: `Please Configure Topics Page`,
  isEmpty(props) {
    return !props
  },
}

export const HolidayScheduleMappedPath = `wm/components/content/holidayschedule`
export const HolidayScheduleEditConfig = {
  emptyLabel: `Please Configure Holiday Schedule`,
  isEmpty(props) {
    return (
      !props || !props.fileReference || props.fileReference.trim().length < 1
    )
  },
}

export const StickyCardsScrollableTextMappedPath = `wm/components/content/stickycardsscrollabletext`
export const StickyCardsScrollableTextEditConfig = {
  emptyLabel: `Please configure Sticky Card Scrollable Text`,
  isEmpty(props) {
    return !props || isEmpty(props) || !props.textSectionHeading
  },
}

export const HelpMeChooseMappedPath = `wm/components/content/ecom/helpmechoose`
export const HelpMeChooseEditConfig = {
  emptyLabel: `Please Configure help me choose Component`,
  isEmpty(props) {
    return !props
  },
}

export const HeroImageVideoMappedPath = `wm/components/content/heroimagevideo`
export const HeroImageVideoEditConfig = {
  emptyLabel: `Please Configure HeroImageVideo`,
  isEmpty(props) {
    return !props
  },
}

export const LeadCaptureFormMappedPath = `wm/components/content/leadcaptureform`
export const LeadCaptureFormEditConfig = {
  emptyLabel: `Please Configure Page Header`,
  isEmpty(props) {
    return !props
  },
}

export const HighlightedStatsMappedPath = `wm/components/content/highlightedstats`
export const HighlightedStatsEditConfig = {
  emptyLabel: `Please Configure Highlighted Stats, Features or Benefits`,
  isEmpty(props) {
    return (
      !props ||
      !props.colorPalette ||
      !props.assetArea ||
      props.assetArea.length < 1
    )
  },
}

export const ImageVideoHeroMappedPath = `wm/components/content/heroimageorvideo`
export const ImageVideoHeroEditConfig = {
  emptyLabel: `Please Configure Hero Image or Video`,
  isEmpty(props) {
    return (
      !props ||
      (isEmpty(get(props, `splitVariantList`, [])) &&
        !get(props, `fullWidthVariant.heroSliderDetails`, ``)) ||
      (isEmpty(get(props, `fullWidthVariant.heroSliderDetails`, [])) &&
        !get(props, `splitVariantList`, ``))
    )
  },
}

export const HeroImageMappedPath = `wm/components/content/heroimage`
export const HeroImageEditConfig = {
  emptyLabel: `Please Configure Hero Image`,
  isEmpty(props) {
    return (
      !props || !props.fileReference || props.fileReference.trim().length < 1
    )
  },
}

export const FeaturedImageWithMetricsMappedPath = `wm/components/content/waterNeutralComponent`
export const FeaturedImageWithMetricsEditConfig = {
  emptyLabel: `Please Configure Featured Image With Metrics Component`,
  isEmpty(props) {
    return !props || !props.backgroundImage
  },
}

export const TwoColumnTextMappedPath = "wm/components/content/twocolumntext"
export const TwoColumnTextEditConfig = {
  emptyLabel: `Please Configure Two Column Text`,
  isEmpty(props) {
    /* show message if "days", "leftHeading", "leftImage" or "componentBackgroundColor" are absent */

    const days = get(props, `days`, [])
    const missingLeftHeadingOrImage =
      filter(days, (day) => !day.leftHeading || !day.leftImage).length > 0
    const missingComponentBackgroundColor = !get(
      props,
      `componentBackgroundColor`,
      ``,
    )

    if (!props) {
      return !props
    }
    if (!days.length) {
      return !days.length
    }
    if (missingLeftHeadingOrImage) {
      return missingLeftHeadingOrImage
    }
    return missingComponentBackgroundColor
  },
}

export const ThreeColumnReportMetricsMappedPath = `wm/components/content/threecolumnreportmetrics`
export const ThreeColumnReportMetricsEditConfig = {
  emptyLabel: `Please Configure Three Column Report Metrics`,
  isEmpty(props) {
    return !props || !props.contentCards || props.contentCards.length < 1
  },
}

export const CustomerSupportMappedPath = `wm/components/content/customer-support`

export const CustomerSupportEditConfig = {
  emptyLabel: `Please Configure Support Module`,

  isEmpty(props) {
    return !props || !props.description || props.description.trim().length < 1
  },
}

export const ContactUsMappedPath = `wm/components/content/contactus`

export const ContactUsEditConfig = {
  emptyLabel: `Please Configure ContactUs`,
  isEmpty(props) {
    return !props
  },
}

export const ErrorPageMappedPath = `wm/components/content/errorpage`
export const ErrorPageEditConfig = {
  emptyLabel: `Please Configure Error Page`,
  isEmpty(props) {
    return !props
  },
}

export const EnergySurchargeCalculatorMappedPath = `wm/components/content/energysurchargecalculator`
export const EnergySurchargeCalculatorEditConfig = {
  emptyLabel: `Please Configure new component`,
  isEmpty(props) {
    return !props
  },
}

export const ProductSelectionMappedPath = `wm/components/content/ecom/productSpecification`
export const ProductSelectionEditConfig = {
  emptyLabel: `Please Configure Product Specification`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const ProductDisclaimerMappedPath =
  "wm/components/content/ecom/disclaimerText"
export const ProductDisclaimerEditConfig = {
  emptyLabel: `Please Configure Disclaimer Text`,
  isEmpty(props) {
    return !props || !props.description || props.description.trim().length < 1
  },
}

export const ProductDescriptionMappedPath =
  "wm/components/content/ecom/productDescription"
export const ProductDescriptionEditConfig = {
  emptyLabel: `Please Configure PDP Product Description`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const ThreeColumnContentBlocksMappedPath = `wm/components/content/threecolumncontentblocks`
export const ThreeColumnContentBlocksEditConfig = {
  emptyLabel: `Please Configure Three Column Content Blocks`,
  isEmpty: (props) => {
    const columnContentBlocks = get(props, `columnContentBlocks`, [])
    return !props || !columnContentBlocks.length
  },
}

export const ProductAvailabilityMappedPath = `wm/components/content/ecom/checkrolloffavailability`
export const ProductAvailabilityEditConfig = {
  emptyLabel: `Please configure Check Roll-off Availability`,
  isEmpty(props) {
    return !props || !props.tab1Heading || props.tab1Heading.trim().length < 1
  },
}

export const ServiceComparisonMappedPath =
  "wm/components/content/ecom/productComparison"
export const ServiceComparisonEditConfig = {
  emptyLabel: `Please Configure Product Comparison`,
  // eslint-disable-next-line no-unused-vars
  isEmpty(props) {
    return true
  },
}

export const CTABreakerMappedPath = `wm/components/content/ctabreaker`
export const CTABreakerEditConfig = {
  emptyLabel: `Please Configure CTA Breaker`,
  isEmpty(props) {
    return !props || !props.colorPalette
  },
}

export const TonnageOverageMappedPath =
  "wm/components/content/ecom/tonnageOverage"
export const TonnageOverageEditConfig = {
  emptyLabel: `Please Configure Tonnage Overage`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const ValuePropositionMappedPath = `wm/components/content/valueproposition`
export const ValuePropositionEditConfig = {
  emptyLabel: `Please Configure Value Proposition`,
  isEmpty: (props) => {
    const propositions = get(props, `propositions`, [])
    return !props || !propositions.length
  },
}

export const FormOnPageMappedPath = `wm/components/content/formonpage`
export const FormOnPageEditConfig = {
  emptyLabel: `Please Configure Form on Page`,
  isEmpty(props) {
    return !props || isEmpty(props.fields)
  },
}

export const BreadcrumbHeaderMappedPath = `wm/components/content/three-level-header`
export const BreadcrumbHeaderEditConfig = {
  emptyLabel: `Please Configure L1-L4 Headers`,
  isEmpty(props) {
    return !props || !props.title
  },
}

export const BasicHeroMappedPath = "wm/components/content/basichero"
export const BasicHeroEditConfig = {
  emptyLabel: `Please configure Basic Hero`,
  isEmpty(props) {
    return !props.heading
  },
}

export const MultimediaMappedPath = `wm/components/content/multimedia`
export const MultimediaEditConfig = {
  emptyLabel: `Please Configure Multimedia`,
  isEmpty(props) {
    return !props || !props.colorPalette || !props.heading
  },
}

export const FullWidthImageVideoMappedPath = `wm/components/content/fullwidthimagevideo`
export const FullWidthImageVideoEditConfig = {
  emptyLabel: `Please Configure Full Width Image Video`,
  isEmpty(props) {
    return (
      !props ||
      !props.colorPalette ||
      !props.heading ||
      !(props.videoPath || props.imageSrc)
    )
  },
}

export const CardGridMappedPath = `wm/components/content/cardgrid`
export const CardGridEditConfig = {
  emptyLabel: `Please Configure Card Grid`,
  isEmpty(props) {
    return !props.cardType
  },
}

export const StickySubNavMappedPath = `wm/components/content/stickysubnav`
export const StickySubNavEditConfig = {
  emptyLabel: `Please Configure Sticky Subnavigation`,
  isEmpty(props) {
    return !props || !props.inheritOrAuthor
  },
}

export const ComparisonTableMappedPath = `wm/components/content/comparisontable`
export const ComparisonTableEditConfig = {
  emptyLabel: `Please Configure Comparison Table`,
  isEmpty(props) {
    return !props || isEmpty(props.columns)
  },
}

export const ContentAccordionMappedPath = `wm/components/content/contentaccordion`
export const ContentAccordionEditConfig = {
  emptyLabel: `Please Configure Content Accordion`,
  isEmpty(props) {
    return !props || !props.style || props.style.trim().length < 1
  },
}

export const ProductCarouselMappedPath = `wm/components/content/productservicescarousel`
export const ProductCarouselEditConfig = {
  emptyLabel: `Please Configure Carousel - Products, Services and General Info`,
  isEmpty(props) {
    return (
      !props ||
      typeof props.cardList !== `object` ||
      props.cardList.length === 0
    )
  },
}

export const SingleColumnTextMappedPath = `wm/components/content/singlecolumntext`
export const SingleColumnTextEditConfig = {
  emptyLabel: `Please Configure Single Column Text`,
  isEmpty(props) {
    return !props || (!props.subhead && !props.body)
  },
}

export const SiteSearchMappedPath = `wm/components/content/sitesearch`
export const SiteSearchEditConfig = {
  emptyLabel: `Please Configure Site Search`,
  isEmpty(props) {
    return !props
  },
}

export const HeaderMappedPath = `wm/components/content/standardnavigation`
export const HeaderEditConfig = {
  emptyLabel: `Please Configure Global Nav`,
  isEmpty(props) {
    return !props || !props.logo || props.logo.trim().length < 1
  },
}

export const ImageMosaicMappedPath = "wm/components/content/imagemosaic"
export const ImageMosaicEditConfig = {
  emptyLabel: `Please Configure Image Mosaic`,
  isEmpty(props) {
    return !props || !props.largeImage
  },
}

export const FooterMappedPath = `wm/components/content/footer`
export const FooterEditConfig = {
  emptyLabel: `Please Configure Footer`,

  isEmpty(props) {
    return !props || !props.logoIcon || props.logoIcon.trim().length < 1
  },
}

export const ImageMappedPath = `wm/components/content/imageComponent`
export const ImageEditConfig = {
  emptyLabel: `Please Configure Image`,

  isEmpty(props) {
    return !props || !props.src || props.src.trim().length < 1
  },
}

export const VideoMappedPath = `wm/components/content/video`
export const VideoEditConfig = {
  emptyLabel: `Please Configure Video`,
  isEmpty(props) {
    return !props || !props.thumbnailImage || !props.videoSource
  },
}

export const UnsubscribeFeedbackMappedPath = `wm/components/content/preferencesearch/unsubscribefeedback`
export const UnsubscribeFeedbackEditConfig = {
  emptyLabel: `Please Configure Unsubscribe Feedback`,
  isEmpty(props) {
    return !props
  },
}

export const CheckAvailabilityModalMappedPath = `wm/components/content/checkProductAvailabilityModal`
export const CheckAvailabilityModalConfig = {
  emptyLabel: `Please Configure Check Availability Modal Component`,
  isEmpty(props) {
    return !props
  },
}

export const CallBackFormMappedPath = `wm/components/content/callbackform`
export const CallBackFormEditConfig = {
  emptyLabel: `Please Configure CallBackForm`,
  isEmpty(props) {
    return !props
  },
}

export const ContactBackMappedPath = `wm/components/content/contactback`
export const ContactBackEditConfig = {
  emptyLabel: `Please Configure Contact Back `,
  isEmpty(props) {
    return !props.heading
  },
}

export const EntryAndContactMappedPath = `wm/components/content/entryandcontact`
export const EntryAndContactEditConfig = {
  emptyLabel: `Please Configure Entry & Contact`,
  isEmpty() {
    return AuthoringUtils.isInEditor()
  },
}

export const LoginFormMappedPath = `wm/components/content/preferencesearch/loginform`
export const LoginFormEditConfig = {
  emptyLabel: `Please Configure Login Form`,
  isEmpty(props) {
    return !props
  },
}

export const FormModalMappedPath = `wm/components/content/formmodal`
export const FormModalEditConfig = {
  emptyLabel: `Please Configure Form Modal`,
  isEmpty() {
    return true
  },
}

export const ProductComparisonTableWithoutPriceMappedPath = `wm/components/content/productComparisonTable`
export const ProductComparisonTableWithoutPriceEditConfig = {
  emptyLabel: `Please Configure Product Comparison Table - Without Price`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.trim().length < 1
  },
}

export const MadlibMappedPath = `wm/components/content/madlib`
export const MadlibEditConfig = {
  emptyLabel: `Please Configure Service Address Tool`,
  isEmpty(props) {
    return !props || !props.lobLabel || props.lobLabel.trim().length < 1
  },
}

export const AddressSearchBarMappedPath = `wm/components/content/addresssearchbar`
export const AddressSearchBarEditConfig = {
  emptyLabel: `Please Configure Address Search - Services Eligibility`,
  isEmpty(props) {
    return !props || !props.lobLabel || props.lobLabel.trim().length < 1
  },
}

export const SupportFormsMappedPath = `wm/components/content/formscomponent`
export const SupportFormsEditConfig = {
  emptyLabel: `Please Configure Support Form`,
  isEmpty(props) {
    return !props || !props.formtype
  },
}

export const RadioListMappedPath = `wm/components/content/radiolist`
export const RadioListEditConfig = {
  emptyLabel: `Please Configure Bulk Form`,
  isEmpty(props) {
    return !props
  },
}

export const BulkFormMappedPath = `wm/components/content/bulkform`
export const BulkFormEditConfig = {
  emptyLabel: `Please Configure Bulk Form`,
  isEmpty(props) {
    return !props
  },
}

export const VirtualTourMappedPath = `wm/components/content/virtualtour`
export const VirtualTourEditConfig = {
  emptyLabel: `Please Configure Virtual Tour`,
  isEmpty(props) {
    return !props || !get(props, `headline`, ``)
  },
}

export const MapMappedPath = `wm/components/content/map`
export const MapEditConfig = {
  emptyLabel: `Please Configure Map`,
  isEmpty(props) {
    return !props || !props.heading || props.heading.length < 1
  },
}

export const ConfirmationMappedPath = `wm/components/content/confirmation`
export const ConfirmationEditConfig = {
  emptyLabel: `Please Configure Confirmation`,
  isEmpty(props) {
    return !props
  },
}

export const AddressSelectorDropdownMappedPath = `wm/components/content/preferencesearch/addressselectordropdown`
export const AddressSelectorDropdownEditConfig = {
  emptyLabel: `Please Configure Address Selector Dropdown`,
  isEmpty(props) {
    return !props
  },
}

export const ManageContactsMappedPath = `wm/components/content/managecontacts/managecontacts`
export const ManageContactsEditConfig = {
  emptyLabel: `Please Configure Manage Contacts component`,
  isEmpty(props) {
    return !props
  },
}

export const CommunicationPreferencesMappedPath = `wm/components/content/preferencesearch/communicationpreferences`
export const CommunicationPreferencesEditConfig = {
  emptyLabel: `Please Configure Communication Preferences`,
  isEmpty(props) {
    return !props
  },
}

export const DisclaimerWithCTAMappedPath = `wm/components/content/disclaimerwithcta`
export const DisclaimerWithCTAEditConfig = {
  emptyLabel: `Please Configure Disclaimer With CTA`,
  isEmpty(props) {
    return !props
  },
}

export const AccordionListMappedPath = `wm/components/content/accordionlist`
export const AccordionListEditConfig = {
  emptyLabel: `Please Configure Bulk Form `,
  isEmpty(props) {
    return !props
  },
}

export const DatePickupSelectorMappedPath = `wm/components/content/datepickupselector`
export const DatePickupSelectorEditConfig = {
  emptyLabel: `Please Configure Date Pickup Selector`,
  isEmpty(props) {
    return !props
  },
}

export const CheckListMappedPath = `wm/components/content/checklist`
export const CheckListEditConfig = {
  emptyLabel: `Please Configure Bulk Form`,
  isEmpty(props) {
    return !props
  },
}

export const LiveChatROMappedPath = `wm/components/content/ecom/livechatentry`
export const LiveChatROEditConfig = {
  emptyLabel: `Please Configure Live Chat for RO`,
  isEmpty(props) {
    return !props
  },
}

export const FeedbackSurveyMappedPath = `wm/components/content/interactivefeedback`
export const FeedbackSurveyEditConfig = {
  emptyLabel: `Please Configure Feedback Survey`,
  isEmpty(props) {
    return !props || !props.mainText
  },
}

export const RequestContainerRepairMappedPath = `wm/components/content/containerrepairaddressentry`
export const RequestContainerRepairEditConfig = {
  emptyLabel: `Please Configure Request Container Repair`,
  isEmpty(props) {
    return !props || !props.heading
  },
}

export const RatingsReviewsMappedPath = `wm/components/content/reviewsAndRatings`
export const RatingsReviewsEditConfig = {
  emptyLabel: `Please Ratings and Reviews Widget`,
  isEmpty(props) {
    return !props
  },
}

export const CustomCoreAccordionMappedPath = "wm/components/accordion"
export const CustomCoreAccordionEditConfig = {
  emptyLabel: "CoreAccordion",
  isEmpty(props) {
    return !props.cqItemsOrder || !props.cqItemsOrder.length === 0
  },
}

export const CustomCoreContainerMappedPath = "wm/components/container"
export const CustomCoreContainerEditConfig = {
  emptyLabel: "CoreContainer",
  isEmpty(props) {
    return !props.cqItemsOrder || !props.cqItemsOrder.length === 0
  },
}

export const CustomResponsiveGridMappedPath =
  "wcm/foundation/components/responsivegrid"
export const CustomResponsiveGridEditConfig = {
  emptyLabel: "ResponsiveGrid",
  isEmpty(props) {
    return !props.cqItemsOrder || !props.cqItemsOrder.length === 0
  },
}
